module.exports = __webpack_public_path__ + "static/Image2-97531964e115b48465c7dc13afde161f.svg";